import ImportResultsPage, {
  importResultsQuery,
} from "@app/pages/import-results/import-results-page";
import type { importResultsPage_MultiUploadQuery } from "@app/queries/importResultsPage_MultiUploadQuery.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute(
  "/_authed/statements/imports/$multiUploadId"
)({
  loader: ({ params }) =>
    loadQuery<importResultsPage_MultiUploadQuery>(
      environment,
      importResultsQuery,
      { id: params.multiUploadId },
      { fetchPolicy: "store-or-network" }
    ),
  head: () => pageHead("Import results"),
  component: ImportResultsRoute,
});

function ImportResultsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading import results</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading import results...</div>
        }
      >
        <ImportResultsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
